import React from 'react';
import { TextField } from './TextField';
import UUID from '@ax2/common/model/UUID';

export interface ParticipantDefinedFieldData {
  id: UUID;
  value: string | null;
  onCompletion: (selection: string | null) => void;
  key?: string;
}

export const ParticipantDefinedField: React.FC<
  ParticipantDefinedFieldData
> = props => {
  const data = {
    ...props,
    onCompletion: (v: string | null, _e: string | null) => {
      props.onCompletion(v);
    },
  };
  return (
    <div>
      <TextField
        {...data}
        error={null}
        placeholder="Specify"
        label="Other:"
      ></TextField>
    </div>
  );
};
